<style lang="scss">
    .gallery-item{
        margin-top:2rem;
        border:1px solid #d3d3d3;
        padding:2rem;
    }
</style>
<template>
    <div class="dashboard container">
        <NavBar/>
        <div class="add-item">
            <b-button variant="primary" @click="createProjectModal">Δημιουργία νέου</b-button>
        </div>
        <div v-if="galleryItems.length ===0 && finishedLoading">
            <h2> Δεν έχετε δημιουργήσει κανένα Project.</h2>

        </div>

        <div v-else class="row">
            <div v-for="item in galleryItems"  :key="item.id" class="gallery-item col-md-4 pt-3">


                <img :src="item.featuredImage" alt="ftured-image" width="300px"/>

                <hr>
                <b-button variant="warning" @click="openEditModal(item.id)" class="m-2">Επεξεργασία</b-button>
                <b-button variant="danger" @click="deleteProject(item.id)" class="m-2">Διαγραφή</b-button>

            </div>
        </div>
        <b-modal id="createProject" size="xl" title="Δημιουργία νέου project" hide-footer>
            <div class="row border-info">
                <div class="col-md-6">
                    <div class="fields">
                        <label>Κεντρική εικόνα (μεγάλη 1400*750):</label><br/>
                        <img v-if="newProject.headerImage" :src="newProject.headerImage" alt="header-image" width="300px"/>
                        <br>
                        <input type="file" ref="file1" name="file1" @change="onSelect(1)"/>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="fields">
                        <label>Εικόνα για τις λίστες (μεσαία και τετράγωνη: 600*600):</label><br/>
                        <img v-if="newProject.featuredImage" :src="newProject.featuredImage" alt="header-image" width="300px"/>
                        <br>
                        <input type="file" ref="file2" name="file2" @change="onSelect(2)"/>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row p-2">
                <div class="col-md-3">
                    <label>Ύψος:</label>
                    <b-form-input id="height" name="height" v-model="newProject.height" placeholder="σε εκατοστά"></b-form-input>
                </div>
                <div class="col-md-3">
                    <label>Μήκος:</label>
                    <b-form-input id="width" name="width" v-model="newProject.width" placeholder="σε εκατοστά"></b-form-input>
                </div>
                <div class="col-md-3">
                    <label>Βάθος:</label>
                    <b-form-input id="depth" name="depth" v-model="newProject.depth" placeholder="σε εκατοστά"></b-form-input>
                </div>
                <div class="col-md-3">
                    <label>Σχήμα:</label>
                    <b-form-select id="shape" name="shape" v-model="newProject.shape">
                        <option value="1">Κυκλικό</option>
                        <option value="2">Τετράγωνο</option>
                    </b-form-select>
                </div>
            </div>
            <hr>
            <div class="row p-2">
                <div class="col-md-12">
                    <div class="fields">

                    <b-tabs>
                        <b-tab title="Ελληνικά">
                            <label>Υλικά:</label>
                            <b-form-input id="materials-el" name="materials-el" v-model="newProject.materials.el"></b-form-input>

                            <label>Περιγραφή</label>
                            <b-form-textarea rows="4" id="materials-el" name="materials-el" v-model="newProject.description.el"></b-form-textarea>
                        </b-tab>
                        <b-tab title="Αγγλικά">
                            <label>Υλικά:</label>
                            <b-form-input id="materials-en" name="materials-en" v-model="newProject.materials.en" :placeholder="newProject.materials.el"></b-form-input>

                            <label>Περιγραφή</label>
                            <b-form-textarea  rows="4" id="materials-el" name="materials-el" v-model="newProject.description.en" :placeholder="newProject.description.el"></b-form-textarea>
                        </b-tab>
                    </b-tabs>

                    </div>
                </div>
            </div>
            <hr>
            <div class="row p2">
                <div class="col-md-12">
                    <h2>Εικόνες άλμπουμ</h2>
                    <div v-for="image of getImages" :key="image.url" class="d-inline-block p-3">
                        <div class="small-img" :style="'background-image: url('+ image.url +'); width:200px;height:200px;background-size:cover;'">
                            <b-button variant="danger" class="float-right m-1" @click="removeImage(image.url)">Διαγραφή</b-button>
                        </div>
                    </div>
                    <br>
                    <b-button variant="primary" @click="toggleAddImage">Προσθήκη εικόνας</b-button>
                    <div class="fields" v-show="addImage">
                        <br>
                        <label>Εσωτερική εικόνα:</label><br/>
                        <input type="file" ref="file3" name="file3" @change="onSelect(3)"/>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row p-2 text-right">
                <div class="col-md-12">
                    <b-button v-if="action==='CREATE'" variant="primary" @click="createProject">Δημιουργία νέου</b-button>
                    <b-button v-if="action==='UPDATE'" variant="primary" @click="updateProject">Αποθήκευση αλλαγών</b-button>
                    <b-alert variant="danger" show v-if="errorMessage" class="text-center">{{errorMessage}}</b-alert>
                </div>


            </div>


        </b-modal>
    </div>
</template>
<script>
    import NavBar from '../components/NavBar'
    import axios from 'axios'

    export default{
        components: {NavBar},

        data(){
            return{
                galleryItems: [],
                finishedLoading: false,
                newProject: {
                    headerImage: null,
                    featuredImage: null,
                    slug: null,
                    shape: 1,
                    materials:{
                        en: null,
                        el: null
                    },
                    height: null,
                    width: null,
                    depth: null,
                    description:{
                        en: null,
                        el: null
                    },
                    images: []
                },
                file:"",
                message:"",
                uploadedImage: null,
                imageChanged: false,
                errorMessage: "",
                action: "CREATE",
                addImage: false,
            }
        },

        computed: {
            getImages(){
                return this.newProject.images;
            }
        },
        created(){
            axios.defaults.headers.common['x-access-token'] = localStorage.getItem('token');
            this.getData();
        },

        methods:{
            toggleAddImage(){
                this.addImage = !this.addImage;
            },
            getData(){
                axios.get(this.apiUrl + '/gallery/').then(result=>{
                    console.log(result);
                    this.galleryItems = null;
                    this.galleryItems = result.data;
                    this.finishedLoading =  true
                })
            },
            removeImage(url){
                let index = this.newProject.images.findIndex(x=> x===url);
                this.newProject.images.splice(index, 1);
                this.imageChanged = true
            },
         async openEditModal(itemId){

                axios.get(this.apiUrl + '/gallery/'+itemId).then(result=>{
                    console.log(result);
                    this.newProject = result.data;
                    if(!this.newProject.materials.el) this.newProject.materials = JSON.parse(this.newProject.materials);
                    if(!this.newProject.description.el) this.newProject.description = JSON.parse(this.newProject.description);
                    this.action = 'UPDATE';
                    this.$bvModal.show('createProject');
                });


            },
            createProjectModal(){
                this.action = 'CREATE';
                this.newProject = {
                    headerImage: null,
                    featuredImage: null,
                    slug: null,
                    shape: '1',
                    materials:{
                        en: null,
                        el: null
                    },
                    height: null,
                    width: null,
                    depth: null,
                    description:{
                        en: null,
                        el: null
                    },
                    images: []
                };
                this.$bvModal.show('createProject');
            },
            createProject(){
                this.errorMessage = null;

                if(!this.newProject.headerImage || !this.newProject.featuredImage){
                    this.errorMessage = "Δεν έχετε εισάγει όλες τις εικόνες (κεντρική & λίστας)";
                    return;
                }
                if(!this.newProject.height || !this.newProject.width || !this.newProject.depth){
                    this.errorMessage = "Δεν έχετε εισάγει όλα τα στοιχεία (ύψος, πλάτος, βάθος)";
                    return;
                }

                axios.post(this.apiUrl + '/gallery/', {galleryItem: this.newProject}).then((result) => {
                    console.log(result);
                    this.getData();
                    this.$bvModal.hide('createProject');
                }).catch(e=>{
                    console.log(e);
                });

            },
            updateProject(){
                this.errorMessage = null;

                if(!this.newProject.headerImage || !this.newProject.featuredImage){
                    this.errorMessage = "Δεν έχετε εισάγει όλες τις εικόνες (κεντρική & λίστας)";
                    return;
                }
                if(!this.newProject.height || !this.newProject.width || !this.newProject.depth){
                    this.errorMessage = "Δεν έχετε εισάγει όλα τα στοιχεία (ύψος, πλάτος, βάθος)";
                    return;
                }

                axios.put(this.apiUrl + '/gallery/' + this.newProject.id, {galleryItem: this.newProject, imageChanged: this.imageChanged}).then((result) => {
                    console.log(result);

                    this.$bvModal.hide('createProject');
                    this.getData();
                }).catch(e=>{
                    console.log(e);
                });
            },

            deleteProject(id){
                if(confirm("Θέλετε σίγουρα να διαγράψετε το έργο;")) {
                    axios.delete(this.apiUrl + '/gallery/' + id).then(() => {
                        this.getData();
                    }).catch(e => {
                        console.log(e);
                    });
                }
            },
            onSelect(num){
                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                const file = this.$refs['file'+ num].files[0];
                this.file = file;
                if(!allowedTypes.includes(file.type)){
                    this.message = "Λάθος αρχείο. Επισυνάψτε jpg/jpeg εικόνα!!!"
                }
                if(file.size>500000){
                    this.message = 'Πολύ μεγάλο αρχείο. Το μέγιστο μέγεθος είναι 500kb'
                }
                this.onSubmit(num);
            },

            async onSubmit(num){
                const formData = new FormData();
                formData.append('image',this.file);
                try{
                    await axios.post(this.apiUrl + '/users/upload-image',formData).then(result=>{
                        let image = result.data.imageUrl;
                        if(num === 1){
                            this.newProject.headerImage = image;
                        }
                        if(num === 2){
                            this.newProject.featuredImage = image;
                        }
                        if(num === 3){
                            if(!this.newProject.images){
                                this.newProject.images = [{url:image}]
                            }else{
                                this.newProject.images.push({url: image});
                            }
                            this.addImage= false;
                            this.imageChanged=true
                        }

                    });

                    this.message = 'Η φωτογραφία ανέβηκε επιτυχώς. Μην ξεχάσετε να την δημοσιεύσετε πατώντας "αποθήκευση"!'
                }
                catch(err){
                    console.log(err);
                }
            }
        }
    }

</script>